import { API_BASE, buildQuery, request } from './api-client';
import type { Paginated, UserActivityLogRow } from '../types';

export function listActivity(
  userId: string,
  query: { page?: number; limit?: number; action?: string; from?: string; to?: string },
) {
  return request<Paginated<UserActivityLogRow>>(
    `${API_BASE}/admin/users-mgmt/${userId}/activity${buildQuery(query as Record<string, unknown>)}`,
  );
}
